<template>
  <div>
    <van-search
      v-model="searchText"
      placeholder="请输入城市名"
      @input="onInput"
      @focus="onFocus"
      @cancel="onCancel"
      :show-action="showCancel"
      style="width: 100vw"
    />
    <div class="search-contant" v-show="show">
      <template v-if="searchList.length">
        <van-cell
          v-for="item in searchList"
          :key="item.cityCode"
          :title="item.cityName"
          @click="selectCity(item)"
        />
      </template>
      <div
        class="padding-16 text-center"
        v-if="!searchList.length && searchText"
      >
        没有找到该城市哦
      </div>
    </div>
    <div class="margin-bottom-8 bg-white padding-12" v-if="historyCity.length">
      <div>历史访问</div>
      <div class="margin-top-8">
        <van-button
          class="cityBtn"
          size="small"
          plain
          v-for="item in historyCity"
          :key="item.cityCode"
          @click="selectCity(item)"
          >{{ item.cityName }}</van-button
        >
      </div>
    </div>
    <div class="margin-bottom-8 bg-white padding-12">
      <div>热门城市</div>
      <div class="margin-top-8">
        <van-button
          class="cityBtn"
          size="small"
          plain
          v-for="item in hotList"
          :key="item.cityCode"
          @click="selectCity(item)"
          >{{ item.cityName }}</van-button
        >
      </div>
    </div>
    <van-index-bar
      :index-list="indexList"
      highlight-color="var(--primary)"
      @select="onIndexBar"
      v-show="!show"
    >
      <template v-for="(value, name) in cityData">
        <van-index-anchor :index="name" :key="name" />
        <template v-for="city in cityData[name]">
          <van-cell
            :key="city.cityCode"
            :title="city.cityName"
            @click="selectCity(city)"
          />
        </template>
      </template>
    </van-index-bar>
  </div>
</template>

<script>
import Vue from 'vue'
import { IndexBar, IndexAnchor, Cell, CellGroup, Search } from 'vant'
import storage from 'good-storage'
import { debounce } from 'throttle-debounce'
import { handleApp } from '@/utils/handle_app'

import { getList, getHotList } from 'api/city'

Vue.use(IndexBar).use(IndexAnchor).use(Cell).use(Search).use(CellGroup)
export default {
  name: 'city',
  data () {
    return {
      cityData: {},
      indexList: [],
      historyCity: storage.get('historyCity', []),
      searchText: '',
      show: false,
      showCancel: false,
      searchList: [],
      list: [],
      hotList: []
    }
  },
  created () {
    this.getList()
    this.getHotList()
  },
  methods: {
    async getList () {
      const list = await getList()
      const cityData = {}
      const indexList = []
      list.forEach((item) => {
        if (!indexList.includes(item.first)) {
          indexList.push(item.first)
        }
        if (!Reflect.has(cityData, item.first)) {
          cityData[item.first] = [item]
        } else {
          cityData[item.first].push(item)
        }
      })
      this.indexList = indexList
      this.cityData = cityData
      this.list = list
    },
    async getHotList () {
      this.hotList = await getHotList()
    },
    selectCity (city) {
      this.show = false
      this.searchList = []
      this.searchText = ''
      let historyCity = storage.get('historyCity', [])
      const result = historyCity.some(
        (item) => item.cityCode === city.cityCode
      )
      if (!result) {
        historyCity.unshift(city)
      }
      if (historyCity.length > 4) {
        historyCity = historyCity.slice(0, 4)
      }
      this.historyCity = historyCity
      storage.set('historyCity', historyCity)
      handleApp('city', {
        cityCode: city.cityCode,
        cityName: city.cityName
      })
    },
    onIndexBar (index) {
      this.$toast({
        message: index,
        duration: 400
      })
    },
    onInput: debounce(500, false, function (value) {
      if (!value) {
        this.searchList = []
        return
      }
      let searchList = []
      searchList = this.list.filter((item) => item.cityName.includes(value))
      this.searchList = searchList
      this.show = true
    }),
    onFocus () {
      this.showCancel = true
    },
    onCancel () {
      this.showCancel = false
      this.show = false
    }
  },
  watch: {
    show (val) {
      if (val) {
        this.$modalHelper.afterOpen() // 打开禁用
      } else {
        this.$modalHelper.beforeClose() // 关闭禁用
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    this.$modalHelper.beforeClose()
    next()
  }
}
</script>

<style lang="scss" scoped>
.cityBtn {
  &:not(:last-child) {
    margin-right: 14px;
  }
  margin-top: 8px;
}
.search-contant {
  position: fixed;
  width: 100%;
  height: calc(100vh - 54px);
  background-color: #fff;
  z-index: 9;
  overflow: auto;
}
</style>
